<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader />
    <div
      class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body"
    >
      <LeftMenu />

      <div
        v-if="canViewXmlImportReport"
        class="m-grid__item m-grid__item--fluid m-wrapper"
      >
        <div class="m-content">
          <div
            id="propertyList"
            class="row"
          >
            <div class="col-xl-12">
              <div
                :m-portlet="'true'"
                class="m-portlet m-portlet--rounded m-portlet--head-sm fullable-portlet"
              >
                <div class="m-portlet__head">
                  <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                      <span class="m-portlet__head-icon">
                        <i
                          class="flaticon-signs-1 m--font-brand m--icon-font-size-lg1 mt-n1"
                        />
                      </span>
                      <h3 class="m-portlet__head-text">
                        Xml Import Report
                      </h3>
                    </div>
                  </div>
                  <div class="m-portlet__head-tools">
                    <ul class="m-portlet__nav">
                      <li class="m-portlet__nav-item">
                        <a
                          href="javascript:"
                          :m-portlet-tool="'fullscreen'"
                          data-trigger="hover"
                          class="m-portlet__nav-link m-portlet__nav-link--icon"
                        ><i class="la la-expand" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="m-portlet__body">
                  <div
                    v-if="entry"
                    class="row"
                  >
                    <div class="col-xl-12">
                      <p>
                        Import started at: <strong>{{ formatDate( entry.start ) }}</strong>
                      </p>
                      <p>
                        Import finished at: <strong>{{ formatDate( entry.end ) }}</strong>
                      </p>
                      <p>
                        Property service limit at the time of run: <strong>{{ entry.runConfig.numberOfProperties }} <span v-if="validPromotion( entry )">(upgraded to {{ entry.runConfig.promotionalProperties }})</span></strong>
                      </p>
                      <p>
                        <button
                          class="btn btn-brand btn-sm"
                          @click="viewRawXml ( entry.agentCode, entry.id )"
                        >
                          view xml file last processed
                        </button>
                      </p>
                      <p>
                        Import report summary:
                      </p>
                      <ul v-if="imageReport">
                        <li>
                          valid, on-line: {{ entry.processingStats.online - publicWithAllImagesInvalid - publicWithNoValidImagesButSomeInProgress }}
                        </li>
                        <li>
                          valid, off-line because all images invalid: {{ publicWithAllImagesInvalid }}
                        </li>
                        <li>
                          valid, off-line because images in progress: {{ publicWithNoValidImagesButSomeInProgress }}
                        </li>
                        <li>
                          valid over the service limit: {{ entry.processingStats.offline }}
                        </li>
                        <li>
                          invalid: {{ entry.processingStats.invalid }}
                        </li>
                        <li>
                          excluded: {{ entry.processingStats.unmatched }}
                        </li>
                      </ul>
                    </div>
                    <div
                      v-if="invalidRecords.length > 0"
                      class="col-xl-12 table_sticky-header"
                    >
                      <p><strong>List of invalid/offline properties</strong></p>
                      <table
                        class="table m-table m-table--head-no-border table table-striped"
                      >
                        <thead>
                          <tr>
                            <th>Issues</th>
                            <th>First Photo</th>
                            <th>Offer</th>
                            <th>Agent Ref / Feed Id</th>
                            <th>Price</th>
                            <th>Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="( invalidRecord, idx ) in invalidRecords"
                            :key="idx"
                            class="m-table__row offline"
                          >
                            <td>
                              <span
                                v-for="issue in invalidRecord.errors"
                                :key="issue"
                                class="m-badge m-badge--danger"
                              >
                                {{ issue }}
                              </span>
                            </td>
                            <td>
                              <img
                                v-for="photo in takeTop( invalidRecord.record.property.photos )"
                                :key="photo.url"
                                :src="photo.url"
                                :alt="photo.number"
                                height="80"
                                style="padding: 4px;"
                              >
                            </td>
                            <td><span v-if="invalidRecord.record.property.offer">{{ $t("common." + invalidRecord.record.property.offer) }}</span></td>
                            <td>
                              {{ invalidRecord.record.property.agentRef }}
                              <br>
                              {{ invalidRecord.record.property.uniqueId }}
                            </td>
                            <td>
                              {{ invalidRecord.record.property.price }} {{ invalidRecord.record.property.currency }}
                            </td>
                            <td>
                              <span v-if="invalidRecord.record.property.type">{{ propertyType(invalidRecord.record.property.type) }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <NoPropertyServices v-if="!canViewXmlImportReport && !loading" />
    </div>
    <AppFooter />
  </div>
</template>

<script>
import { getPropertyService, getUser } from '../../../functions.ts';
import dayjs from 'dayjs';
import xmlimportapi from '../../../api-clients/xml-import-api.js';
import adminapi from '../../../api-clients/admin-api.js';
import { i18n } from '../../../i18n.js';
import data from '../../../data.js';
import LeftMenu from '../common/menus/LeftMenu.vue';
import AppHeader from '../common/Header.vue';
import AppFooter from '../common/Footer.vue';
import NoPropertyServices from '../services/Property.vue';

export default {
    components: {
        LeftMenu,
        AppHeader,
        AppFooter,
        NoPropertyServices,
    },
    data() {
        return {
            user: {},
            propertyService: { Status: 'NOT_ACTIVE' },
            entry: null,
            report: null,
            imageReport: null,
            invalidRecords: [],
            propertyTypes: [],
            loading: true,
        };
    },
    computed: {
        canViewXmlImportReport() {
            let allowedStatuses = [ 'ACTIVE', 'ACTIVE_EXPIRED', 'ACTIVE_PENDING', 'ACTIVE_SUSPENDED' ];
            if ( !allowedStatuses.includes( this.propertyService.Status ) ) {
                return false;
            }
            return this.propertyService.ImportType === 'XML';
        },
        publicWithAllImagesInvalid() {
            return this.imageReport.filter( ( p ) => p.total > 0 && p.valid === 0 && p.invalid === p.total ).length;
        },
        publicWithNoValidImagesButSomeInProgress() {
            return this.imageReport.filter( ( p ) => p.total > 0 && p.valid === 0 && p.invalid < p.total ).length;
        },
    },
    async mounted() {
        this.propertyService = await getPropertyService();
        this.user = getUser();

        this.propertyTypes = data.propertyTypes();

        mApp.block( 'body', { 'message': i18n.global.t( 'common.LoadingDataPleaseWait' ) } );

        try {
            if ( this.canViewXmlImportReport ) {
                await this.load();
                await this.loadImageReport();
                this.invalidRecords = this.getInvalidWithValidationErrors();
            }
        } catch ( e ) {
            swal( { title: this.$t( 'error.AnErrorOccurred' ),
                text: this.$t( 'error.SomethingWentWrong' ),
                type: 'error' } );
        }
        mApp.unblock( 'body' );
        this.loading = false;
    },
    methods: {
        formatDate( date ) {
            return dayjs( date ).tz().format( 'DD/MM/YYYY H:mm:ss' );
        },
        async loadImageReport() {
            let url = '/photo-report-detailed/' + this.user.Login;

            const response = await adminapi.get( url );

            if ( response.status !== 200 ) {
                swal( { title: this.$t( 'error.AnErrorOccurred' ),
                    text: this.$t( 'error.SomethingWentWrong' ),
                    type: 'error' } );
                return;
            }

            var imageReport = response.data;

            // sorting - first invalid, then warning, then ok
            function compareImageReport( first, second ) {
                let isFirstoffline = ( first.total > 0 && first.total === first.invalid );
                let isSecondoffline = ( second.total > 0 && second.total === second.invalid );

                if ( isFirstoffline && !isSecondoffline ) {
                    return -1;
                }

                if ( !isFirstoffline && isSecondoffline ) {
                    return 1;
                }

                let isFirstWarning = ( first.total === 0 || first.invalid > 0 || first.total > first.ok );
                let isSecondWarning = ( second.total === 0 || second.invalid > 0 || second.total > second.ok );

                if ( isFirstWarning && !isSecondWarning ) {
                    return -1;
                }

                if ( !isFirstWarning && isSecondWarning ) {
                    return 1;
                }

                return 0;
            }

            imageReport = imageReport || [];

            imageReport.sort( compareImageReport );

            this.imageReport = imageReport;
        },
        async load() {
            let lastEntriesResponse = await xmlimportapi.get( `/history/${ this.user.Login }?take=1` );

            if ( lastEntriesResponse.status !== 200 ) {
                swal( { title: this.$t( 'error.AnErrorOccurred' ),
                    text: this.$t( 'error.SomethingWentWrong' ),
                    type: 'error' } );
                return;
            }

            let lastEntriesData = lastEntriesResponse.data;

            if ( lastEntriesData.length === 0 ) {
                swal( { title: this.$t( 'error.AnErrorOccurred' ),
                    text: this.$t( 'error.SomethingWentWrong' ),
                    type: 'error' } );
                return;
            }

            this.entry = lastEntriesData[ 0 ];

            let reportIdUrl = `/report/${ this.user.Login }/${ this.entry.id }`;

            let reportResponse = await xmlimportapi.get( reportIdUrl );

            if ( reportResponse.status !== 200 ) {
                swal( { title: this.$t( 'error.AnErrorOccurred' ),
                    text: this.$t( 'error.SomethingWentWrong' ),
                    type: 'error' } );
                return;
            }

            this.report = reportResponse.data;
        },
        validPromotion( entry ) {
            if ( !entry.runConfig.promotionStartDate || !entry.runConfig.promotionEndDate ) {
                return false;
            }
            const promotionStartDate = new Date( entry.runConfig.promotionStartDate );
            const promotionEndDate = new Date( entry.runConfig.promotionEndDate );

            const start = new Date( entry.start );

            return start >= promotionStartDate && start <= promotionEndDate;
        },
        async viewRawXml( login, entryId ) {
            let url = `/report/${login}/${entryId}/xml`;

            const response = await xmlimportapi.get( url );

            if ( response.status !== 200 ) {
                swal( { title: this.$t( 'error.AnErrorOccurred' ),
                    text: this.$t( 'error.SomethingWentWrong' ),
                    type: 'error' } );
                return;
            }

            window.open( response.data.url, '_blank' );
        },

        getInvalidWithValidationErrors() {
            let invalid = [];

            for ( let record of this.report.properties ) {
                let errors = record.validationErrors || [];

                let imageReports = this.imageReport.filter( ( p ) => p.agentRef === record.property.agentRef && p.uniqueId === record.property.uniqueId );

                if ( imageReports.length > 0  ) {
                    let imageReport = imageReports[ 0 ];
                    if ( imageReport.total > 0 && imageReport.invalid === imageReport.total ) {
                        errors.push( 'All images invalid' );
                    } else if ( imageReport.total > 0 && imageReport.valid === 0 && imageReport.invalid < imageReport.total ) {
                        errors.push( 'Images in progress' );
                    }
                }

                if ( errors.length > 0 ) {
                    invalid.push( { record,
                        errors } );
                }
            }

            return invalid;
        },
        getErrors( record ) {
            let errors = record.validationErrors || [];

            let imageReport = this.imageReport.find( ( p ) => p.agentRef === record.property.agentRef && p.uniqueId === record.property.uniqueId );

            if ( imageReport ) {
                if ( imageReport.total > 0 && imageReport.invalid === imageReport.total ) {
                    errors.push( 'All images invalid' );
                } else if ( imageReport.total > 0 && imageReport.valid === 0 && imageReport.invalid < imageReport.total ) {
                    errors.push( 'All images in progress' );
                }
            }

            return errors;
        },
        takeTop( array ) {
            if ( !array ) {
                return [];
            }
            // order by number property
            array.slice().sort( ( a, b ) => {
                return a.number - b.number;
            } );
            return array.slice( 0, 1 );
        },
        propertyType( type ) {
            let found = this.propertyTypes.find( ( t ) => t.Id === type );

            if ( found ) {
                return found.Labels.en;
            }

            return '';
        },
    },

};
</script>

